import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { TotalPriceService } from "./totalprice.service";
import { SaleMethodNature } from "src/app/frontoffice/sales/model/sale-method-branch.model";
import { InvoiceStatus } from "../../../model/invoice.model";

@Component({
  selector: "order-totalprice",
  templateUrl: "./totalprice.component.html",
  styleUrls: ["./totalprice.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TotalPriceService],
})
export class TotalPriceComponent extends BaseListComponent {
  @ViewChild("clearButton") clearButton!: ElementRef;
  isContentFitting: boolean = true;

  constructor(public totalPriceService: TotalPriceService, public cd: ChangeDetectorRef) {
    super();
    this.NoLog = true;
    this.totalPriceService.order.cd_Total = this.cd;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.setShowChangeClearingButton();
  }

  ngAfterViewInit() {
    if (this.totalPriceService.order.currentSaleMethodNature === this.totalPriceService.order.SaleMethodNature.Restaurant) {
      setTimeout(() => {
        this.checkContentWidth();
      }, 10);
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize() {
    if (this.totalPriceService.order.currentSaleMethodNature === this.totalPriceService.order.SaleMethodNature.Restaurant) {
      this.checkContentWidth();
    }
  }

  checkContentWidth() {
    const divElement = this.clearButton.nativeElement;
    const contentWidth = divElement.scrollWidth;
    const divWidth = divElement.clientWidth;

    this.isContentFitting = contentWidth <= divWidth;
    this.cd.markForCheck();
  }

  public changeClearing(): void {
    this.totalPriceService.openMixClearingDialog(false);
  }

  public onApplySnapChanges(value: boolean): void {
    this.totalPriceService.order.invoice.ApplySnap = value;
  }

  private setShowChangeClearingButton(): void {
    const invoiceIsCleared = this.totalPriceService.order.invoice.StatusCode == InvoiceStatus.Cleared;
    if (!invoiceIsCleared) return;
    const isFastFood = this.totalPriceService.order.saleMethodBranch.SaleMethodNatureCode === SaleMethodNature.FastFood;
    const isRestaurant = this.totalPriceService.order.saleMethodBranch.SaleMethodNatureCode === SaleMethodNature.Restaurant;
    const isSalonOrFastFood = isFastFood || isRestaurant;
    if (!isSalonOrFastFood) return;
    const hasAccess = this.totalPriceService.order.HasAccess(isFastFood ? "ClearClearedStatus" : "ClearClearingStatus");
    this.totalPriceService.showChangeClearing = invoiceIsCleared && hasAccess && isSalonOrFastFood;
  }
}
